var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            model: _vm.form,
            "label-position": "right",
            "label-width": _vm.formLabelWidth,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "手机号：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "手机号" },
                model: {
                  value: _vm.form.mobile,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "mobile", $$v)
                  },
                  expression: "form.mobile",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户ID：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "uuid" },
                model: {
                  value: _vm.form.userid,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userid", $$v)
                  },
                  expression: "form.userid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "uid：" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "uid" },
                model: {
                  value: _vm.form.uid,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "uid", $$v)
                  },
                  expression: "form.uid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "房间号：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "房间号" },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "投屏码：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "投屏码" },
                model: {
                  value: _vm.form.castCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "castCode", $$v)
                  },
                  expression: "form.castCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "渠道：" } },
            [
              _c("DynamicOption", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.appid,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appid", $$v)
                  },
                  expression: "form.appid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "云桌面：" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "全部" },
                  model: {
                    value: _vm.form.cloudType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "cloudType", $$v)
                    },
                    expression: "form.cloudType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "不使用云桌面", value: "0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "威尔云桌面", value: "1" },
                  }),
                  _c("el-option", {
                    attrs: { label: "阿里云桌面", value: "2" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "时长：" } },
            [
              _c("el-input-number", {
                attrs: {
                  placeholder: "请输入分钟数",
                  min: 0,
                  max: 99999,
                  controls: false,
                },
                model: {
                  value: _vm.form.timeMinutes,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "timeMinutes", $$v)
                  },
                  expression: "form.timeMinutes",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态：" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "全部" },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "进行中", value: "1" } }),
                  _c("el-option", { attrs: { label: "已结束", value: "0" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "创建日期：" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.startEndDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startEndDate", $$v)
                  },
                  expression: "form.startEndDate",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "_delete_btn",
                  attrs: { icon: "el-icon-delete" },
                  on: { click: _vm.onSubmitClear },
                },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "_onSubmit_btn", attrs: { label: " " } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "RABBIT_METTING-MANAGE_SEARCH",
                      expression: "'RABBIT_METTING-MANAGE_SEARCH'",
                    },
                  ],
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("\n        搜索\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "table_header" }, [
        _c("div", [_vm._v("会议列表")]),
        _c(
          "div",
          {
            directives: [
              {
                name: "auth",
                rawName: "v-auth",
                value: "RABBIT_METTING-MANAGE_END",
                expression: "'RABBIT_METTING-MANAGE_END'",
              },
            ],
            staticClass: "table_header_stop",
          },
          [_c("span", { on: { click: _vm.stopAll } }, [_vm._v("批量终止")])]
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { prop: "code", label: "房间号", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticStyle: { color: "#1d28e2" } }, [
                      _vm._v(" " + _vm._s(scope.row.code)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 1
                      ? _c("span", { staticStyle: { color: "#209763" } }, [
                          _vm._v("\n          进行中\n        "),
                        ])
                      : _c("span", { staticStyle: { color: "#db0d0d" } }, [
                          _vm._v(" 已结束 "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "开始时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "duration", label: "会议时长（时-分-秒）" },
          }),
          _c("el-table-column", {
            attrs: { prop: "address", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.permission.metting_detail
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.goHref(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          详情\n        ")]
                        )
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "RABBIT_METTING-MANAGE_END",
                                expression: "'RABBIT_METTING-MANAGE_END'",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.saveID(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          终止\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          "current-page": _vm.params.current,
          "page-sizes": [10, 20, 40, 50, 100],
          "page-size": _vm.params.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.stopTitle,
            visible: _vm.deleteStrategy,
            width: "30%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteStrategy = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-text" }, [
            _vm._v("\n      远程终止会议将导致会议"),
            _c("span", { staticClass: "red_text" }, [_vm._v("立即结束")]),
            _vm._v("\n      ，会议所有人离开房间，云桌面资源释放，"),
            _c("span", { staticClass: "red_text" }, [_vm._v("且无法再次开启")]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteStrategy = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingSure, type: "primary" },
                  on: { click: _vm.dialogSure },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }